//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'
// import JSONBIG from 'json-bigint'
export default {
    components: {},
    props: [],
    data() {
        return {
            // 搜索部分
            formInline: {
                name: '',
            },

            //弹窗展示部分

            dialogVisible_add: false,
            dialogVisible_amend: false,
            dialogVisible_amendTitle: false,
            dialogVisible_remove: false,
            dialogVisible_removeTitle: false,

            //删除操作id

            removeList_id: '',
            removeTit: '',

            // 弹窗添加数据

            dynamicValidateForm: {
                name: '测试',
                slotNum: '1',
                xgname: "",
                xgslotNum: "",
                xgid: ""
            },

            //表格部分
            tableData: [
            ],
            loading: true,

            //分页部分
            pagination: {
                page: 1,
                size: 10,
                total: 0,
            },
        };
    },
    mounted() { },
    created() {
        this.fn()
    },
    methods: {

        // 确认添加品牌

        addTrue() {
            try {
                let obj = {
                    brandName: this.dynamicValidateForm.name,
                    sort: this.dynamicValidateForm.slotNum
                }
                // axios({
                //     method: "post",
                //     url: "/cm-api/admin/brand/addBrand",
                //     params: obj
                // }).then(res => {
                //     console.log(res)
                // })
                this.$http.brandApi.getAddbrand(obj).then(res => {
                    console.log(res);
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                })
                this.dialogVisible_add = false
                this.fn()
                // this.fn()

            } catch (err) {
                console.log(err)
            }
        },

        //品牌列表

        fn() {
            let obj = {
                pageNum: this.pagination.page,
                pageSize: this.pagination.size

            }
            this.$http.brandApi.getBrandList(obj).then(res => {
                this.tableData = res.data.szProductsBrandList
                this.pagination.total = res.data.count
                this.loading = false
            })
        },



        //查询

        chaxun() {
            try {

                this.loading = true
                this.pagination.page = 1

                let obj = {
                    pageNum: 1,
                    pageSize: 10,
                    brandName: this.formInline.name
                }
                this.$http.brandApi.getBrandList(obj).then(res => {
                    console.log(res);
                    this.tableData = res.data.szProductsBrandList
                    this.pagination.total = res.data.count
                    this.loading = false
                })
            } catch (err) {
                console.log(err)
            }
        },

        //清空

        handleReset() {
            this.formInline.name = ""
            this.fn()
        },

        //添加操作

        addBrand() {
            this.dialogVisible_add = true
            this.dynamicValidateForm.slotNum = ""
            this.dynamicValidateForm.name = ""
        },

        //删除操作

        async removeList(val) {
            console.log(val.id.toString());
            await this.$http.brandApi.getRemTitle({ brandId: val.id.toString() }).then(res => {
                console.log(res);
                if (res.data == 0) {
                    this.dialogVisible_remove = true
                } else {
                    this.dialogVisible_removeTitle = true
                    this.removeTit = res.data

                }
            })
            this.removeList_id = val.id.toString()

        },
        removeTrue() {
            try {
                this.loading = true
                this.$http.brandApi.getBrandRem({ id: this.removeList_id }).then(res => {
                    console.log(res);
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                    this.dialogVisible_remove = false
                    this.loading = false

                })
                this.fn()
            } catch (err) {
                console.log(err)
            }
        },

        //修改操作

        async amend(val) {
            console.log(val.id.toString());
            await this.$http.brandApi.getRemTitle({ brandId: val.id.toString() }).then(res => {
                this.removeTit = res.data
                this.dialogVisible_amendTitle = true
                // this.dialogVisible_amend = true
            })
            this.dynamicValidateForm.xgname = val.brandName
            this.dynamicValidateForm.xgslotNum = val.sort
            this.dynamicValidateForm.xgid = val.id.toString()
            // this.awayamend()
        },
        quxiaoAmend() {
            this.dialogVisible_amendTitle = false
            this.dialogVisible_amend = false
        },
        awayamend() {
            this.dialogVisible_amend = true
            this.dialogVisible_amendTitle = false

        },
        amendList() {
            try {
                this.loading = true
                let obj = {
                    brandName: this.dynamicValidateForm.xgname,
                    sort: this.dynamicValidateForm.xgslotNum,
                    id: this.dynamicValidateForm.xgid,
                }
                this.$http.brandApi.getBrandChanged(obj).then(res => {
                    console.log(res)
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                })
                this.dialogVisible_amend = false
                this.loading = false
                this.fn()
            } catch (err) {

            }
        },

        //分页操作

        handleCurrentChange(val) {
            console.log(val);
            // this.pagination.page = val
            let obj = {
                pageNum: val,
                pageSize: 10,
                brandName: this.formInline.name
            }
            this.$http.brandApi.getBrandList(obj).then(res => {
                console.log(res);
                this.tableData = res.data.szProductsBrandList
                this.pagination.total = res.data.count
                this.loading = false
            })
        },

        handleSizeChange(val) {

        }
    },
};
